import { useMemo, useState } from 'react';
import { CULTURE_QUESTIONS } from '@/config/cultureQuestions';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Label } from '@/components/ui/Label';
import { cn } from '@/lib/utils';

interface Props {
  onComplete: (results: Record<string, number>) => void;
}

const CANDIDATE_QUESTIONS = CULTURE_QUESTIONS.filter((question) => question.forCandidate);

export function CultureFitRunner({ onComplete }: Props) {
  const [answers, setAnswers] = useState<Record<string, number>>({});

  const answeredCount = useMemo(
    () => CANDIDATE_QUESTIONS.filter((question) => typeof answers[question.id] === 'number').length,
    [answers]
  );

  const allCompleted = answeredCount === CANDIDATE_QUESTIONS.length;

  return (
    <Card className="mx-auto max-w-3xl">
      <CardHeader>
        <CardTitle className="text-lg">Cultura Organizacional (Ajuste Cultural)</CardTitle>
        <p className="text-sm text-muted-foreground">
          Responde cada afirmación del 1 al 5 según qué tanto te describe en un entorno laboral ideal.
        </p>
      </CardHeader>
      <CardContent className="space-y-5">
        {CANDIDATE_QUESTIONS.map((question, index) => (
          <div key={question.id} className="rounded-lg border p-4">
            <p className="mb-3 text-sm font-medium">
              {index + 1}. {question.candidateText || question.text}
            </p>
            <div className="space-y-2">
              <Label className="text-xs text-muted-foreground">Escala Likert (1 = Muy en desacuerdo, 5 = Muy de acuerdo)</Label>
              <div className="grid grid-cols-5 gap-2">
                {[1, 2, 3, 4, 5].map((value) => (
                  <button
                    key={value}
                    type="button"
                    className={cn(
                      'rounded-md border px-2 py-2 text-sm font-medium transition-colors',
                      answers[question.id] === value
                        ? 'border-primary bg-primary text-primary-foreground'
                        : 'hover:bg-muted'
                    )}
                    onClick={() =>
                      setAnswers((prev) => ({
                        ...prev,
                        [question.id]: value,
                      }))
                    }
                  >
                    {value}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}

        <div className="flex items-center justify-between border-t pt-4">
          <p className="text-xs text-muted-foreground">
            Contestadas: {answeredCount} / {CANDIDATE_QUESTIONS.length}
          </p>
          <Button type="button" disabled={!allCompleted} onClick={() => onComplete(answers)}>
            Finalizar prueba
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
